import {Put} from './Put';

export const PutRoutes = {
  [Put.ResetPassword]: (id: string) => `/api/v1/users/${id}/password`,
  [Put.UpdatePassword]: '/api/v1/users/password/update',
};
